import { EUserPhoneNumberStatus } from '@/src/app/core/enums';
import { IDialogResult } from '@/src/app/core/interfaces';
import { AppConfigService } from '@/src/app/core/services';
import { Component, Inject, Injector } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SuperDialogComponent } from '../super-dialog/super-dialog.component';
import { IVerifyUserPhoneNumberModalData } from './verify-user-phone-number-modal.interface';

@Component({
  selector: 'aup-missing-phone-modal',
  templateUrl: './verify-user-phone-number-modal.component.html',
  styleUrl: './verify-user-phone-number-modal.component.scss',
  standalone: false,
})
export class VerifyUserPhoneNumberModalComponent extends SuperDialogComponent<VerifyUserPhoneNumberModalComponent> {
  /**
   * @inheritdoc
   * @date 10/26/2023 - 2:03:50 PM
   */
  override content = 'default';

  /**
   * Sizes map for modal
   * @date 10/26/2023 - 2:03:50 PM
   *
   * @type {{ default: { small: { width: string; height: string; }; other: { width: string; height: string; }; }; }}
   */
  sizesMap = {
    default: {
      small: {
        width: '100vw',
        height: 'auto',
      },
      other: {
        width: '776px',
        height: 'auto',
      },
    },
  };

  eUserPhoneNumberStatus = EUserPhoneNumberStatus;
  /**
   * Creates an instance of MissingPhoneModalComponent.
   * @date 10/26/2023 - 2:03:50 PM
   *
   * @constructor
   * @param {Injector} injector
   * @param {MatDialogRef<VerifyUserPhoneNumberModalComponent, IDialogResult>} dialogRef
   * @param {IVerifyUserPhoneNumberModalData} data
   */
  constructor(
    public override injector: Injector,
    public override dialogRef: MatDialogRef<VerifyUserPhoneNumberModalComponent, IDialogResult>,
    @Inject(MAT_DIALOG_DATA)
    public data: IVerifyUserPhoneNumberModalData,
    private appConfigService: AppConfigService
  ) {
    super(injector, dialogRef);
  }

  onVerifyPhone() {
    window.location.href = this.appConfigService.getConfig()!.verifyPhoneUrl || '';
  }
}
